// Convert string to search (like `maçonnerie` to `maconnerie`, `Amélioration` to `amelioration`)
const normalizeString = (string: string) => {
  return string.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};

export default normalizeString;
